// Acadia Media & Marketing — 2026 Brand Refresh
export const BAY_ISLE    = "#213e44";   // anchor — headlines, dark bg
export const TERRACOTTA  = "#c38762";   // accent — CTAs, highlights
export const SEMI_SWEET  = "#6b5250";   // body text, depth
export const PLASTER     = "#f2eeea";   // default background
export const PROPER_GREY = "#aca7a6";   // secondary text, accents
export const WHITE       = "#ffffff";
export const RULE        = "#e0d9d2";

export const FONT_DISPLAY = "'Archivo', sans-serif";
export const FONT_DISPLAY_HEAVY = "'Archivo Black', sans-serif";
export const FONT_BODY    = "'Montserrat', sans-serif";
export const FONT_SERIF   = "'EB Garamond', Georgia, serif";
